(() => {
  const init = () => {
    if (location.href.indexOf('customer/camping_subscription/guest') < 1 ) {
      return
    }
    $('#camping-subscription-login-confirmation-modal').click();
  }
  $(init);
})();


